import { html } from 'lit';
import { when } from 'lit/directives/when.js';
import { getText } from '@utils/i18n.js';
import { overflow } from '@icons';

const DESCRIPTION = 'place holder text';

export const shouldSkipTour = userInitiated => localStorage.getItem('tour-seen') && !userInitiated;

export const createTourStep = ({ element, title, html, side, align }) => ({
  element,
  popover: {
    description: DESCRIPTION,
    title,
    html,
    side,
    align,
  },
});

export const createFileMenuStep = element =>
  createTourStep({
    title: getText('File Menu'),
    side: 'bottom',
    align: 'start',
    html: () =>
      html`<p>
        ${getText(
          'Access the File menu to start a new experiment, open or save a file, or export your graphs and data.',
        )}
      </p>`,
    element,
  });

export const createGraphOptionsStep = (element, includeGaProInfo = false) =>
  createTourStep({
    title: getText('Graph Options'),
    side: 'top',
    align: 'start',
    html: () => html`
      <p>
        ${getText(
          'Use ',
          'general',
          'App tour: full context: Use Graph Options to analyze your data or change how your graph looks and behaves.',
        )}
        <b
          >${getText(
            'Graph Options ',
            'general',
            'App tour: full context: Use Graph Options to analyze your data or change how your graph looks and behaves.',
          )}</b
        >
        ${getText(
          'to analyze your data or change how your graph looks and behaves. Options include stats, curve fits, tangents, and more.',
          'general',
          'App tour: preceded by text, "Use Graph Options"',
        )}
      </p>
      ${when(
        includeGaProInfo,
        () => html`
          <p>
            ${getText(
              'Graphical Analysis Pro unlocks advanced tools like custom fits, FFTs, histograms, and a second y-axis.',
            )}
          </p>
        `,
      )}
    `,
    element,
  });

export const createOtherOptionsStep = element =>
  createTourStep({
    title: getText('Other Options'),
    side: 'bottom',
    align: 'end',
    html: () =>
      html`<p>
          ${getText(
            'Click the ',
            'general',
            'App tour. Immediately followed by text, "Options Icon"',
          )}
          <b>${getText('Options')}</b>
          ${getText(
            ' icon in the top-right corner to adjust font and button sizes, open the user manual, or view what’s new in this version.',
          )}
        </p>
        <p>
          ${getText(
            'You’ll also see a smaller ',
            'general',
            'App tour. full context: "You’ll also see a smaller Options icon next to data set and column names."',
          )}
          <b
            >${getText(
              'Options ',
              'general',
              'App tour. full context: "You’ll also see a smaller Options icon next to data set and column names."',
            )}</b
          >
          ${getText(
            'icon ',
            'general',
            'App tour. full context: "You’ll also see a smaller Options icon next to data set and column names."',
          )}
          <vst-ui-icon .icon="${overflow}" aria-hidden="true"></vst-ui-icon>
          ${getText(
            'next to data set and column names. Click or tap this icon to rename, delete, or customize display settings for that specific item.',
            'general',
            'App tour. full context: "You’ll also see a smaller Options icon next to data set and column names."',
          )}
        </p>`,
    element,
  });

export const createTourButtonStep = ({ element, html }) =>
  createTourStep({
    title: getText('Help Tour'),
    side: 'bottom',
    align: 'end',
    element,
    html,
  });

export const createViewOptionsStep = ({ element, html }) =>
  createTourStep({
    title: getText('View Options'),
    side: 'bottom',
    align: 'end',
    html,
    element,
  });

export const createXAndYAxisStep = element =>
  createTourStep({
    title: getText('x and y axes'),
    side: 'right',
    align: 'center',
    html: () =>
      html`<p>
        ${getText(
          'Choose which data appear on your graph’s x- and y-axes. You can also turn on additional data runs from here.',
        )}
      </p>`,
    element,
  });

export const createZoomStep = element =>
  createTourStep({
    title: getText('Zoom'),
    side: 'top',
    align: 'start',
    html: () =>
      html`<p>
        ${getText('Zoom in on a section of data or fit the graph to display all collected data.')}
      </p>`,
    element,
  });
